import React from 'react'
import BaseIcon from 'react-icon-base'
import { withTranslation } from 'react-i18next'

const NoActivitiesMan = props => {
  const baseIconProps = { ...props }
  delete baseIconProps.topText

  return (
    <BaseIcon width="350" height="320" viewBox="0 0 350 320" {...baseIconProps}>
      <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero" transform="translate(114 116)">
          <path
            fill="#E8E9EB"
            d="M27.966 87.311l-5.465-2.537a126.743 126.743 0 0 0-8.396 19.145l9.497 2.335a119.488 119.488 0 0 1 4.364-18.943zM75.183 89.696L70.6 93.58a73.885 73.885 0 0 0 15.013 15.352l5.12-8.298a66.081 66.081 0 0 1-15.551-10.937z"
          />
          <path
            fill="#FFA897"
            d="M23.87 138.822c-1.574-14.184-.985-28.255-.281-32.606l-9.497-2.335c-5.53 15.327-6.95 21.239-8 35.462l17.779-.52z"
          />
          <path
            fill="#FFA897"
            d="M6.105 139.393c-.625 4.1-.5 8.277.371 12.333a32.512 32.512 0 0 0 17.446.977l3.25-5.469a40.098 40.098 0 0 0-3.289-8.36 42.785 42.785 0 0 0-11.903-.407 44.8 44.8 0 0 0-5.875.926z"
          />
          <ellipse cx="43.389" cy="199.479" fill="#F4EBE5" rx="43.389" ry="4.25" />
          <path fill="#4A3A4F" d="M30.334 136.627l4.66 56.206H22.321l1.203-55.787z" />
          <path
            fill="#603141"
            d="M22.168 191.932a5.684 5.684 0 0 0-4.088 1.615 5.583 5.583 0 0 0-1.684 4.031c.064.698 4.275.888 9.407.432 5.133-.457 9.241-1.409 9.177-2.107v-3.806c-6.438 1.65-11.532-.165-12.812-.165z"
          />
          <path
            fill="#4A3A4F"
            d="M20.453 134.686c-.134 2.053 1.403 3.84 3.469 4.035 0 0 9.382 1.789 20.479 2.842 7.013.75 14.077.916 21.118.495 2.071.132 3.874-1.39 4.07-3.439.134-2.053-1.402-3.84-3.468-4.034l-41.598-3.375c-2.07-.133-3.874 1.39-4.07 3.438v.038z"
          />
          <path
            fill="#E8E9EB"
            d="M50.98 63.776C28.58 62.012 21.77 86.423 21.77 86.423l-4.198 45.231c-.118 1.464.981 2.746 2.458 2.867 0 0 31.166 4.428 50.032 3.997a2.783 2.783 0 0 0 2.893-2.436l3.174-45.32s-2.752-25.16-25.15-26.986z"
          />
          <path fill="#F7636C" d="M33.97 91.232l-6.605 34.104 5.542 6.42 6.489-5.456-.998-34.713z" />
          <path fill="#F7636C" d="M35.966 94.099l4.684-4.162-.908-3.742-6.323-.203-1.165 2.994z" />
          <path fill="#4A3A4F" d="M65.57 140.573l7.27 53.529H60.182l-1.395-52.983z" />
          <path
            fill="#603141"
            d="M60.17 193.201a5.711 5.711 0 0 0-4.182 1.567 5.61 5.61 0 0 0-1.745 4.079c.064.698 4.275.888 9.408.431 5.132-.456 9.24-1.408 9.177-2.106v-3.806c-4.176.916-8.509.86-12.659-.165z"
          />
          <path
            fill="#FFA897"
            d="M102.061 79.965c2.189 25.045-3.302 24.627-11.391 20.655l-5.12 8.298c20.645 14.426 31.55-2.119 34.238-28.966l-17.727.013z"
          />
          <path
            fill="#FFA897"
            d="M108.064 65.54l-.077-10.607a1.198 1.198 0 0 0-1.203-1.18h-3.251c-.66.007-1.19.539-1.19 1.192l.115 11.165-3.405 5.38a40.078 40.078 0 0 0 3.046 8.462 42.95 42.95 0 0 0 11.89.762 44.449 44.449 0 0 0 5.901-.762c.75-4.081.75-8.263 0-12.345 0 0-6.694-2.372-11.826-2.068z"
          />
          <path
            fill="#F59784"
            d="M12.953 56.036a7.266 7.266 0 0 0 1.712 5.361 7.394 7.394 0 0 0 5.046 2.57l61.526 4.922a7.415 7.415 0 0 0 5.375-1.716 7.287 7.287 0 0 0 2.573-4.983 7.266 7.266 0 0 0-1.731-5.328 7.394 7.394 0 0 0-5.027-2.551l-61.526-4.923a7.415 7.415 0 0 0-5.375 1.716 7.287 7.287 0 0 0-2.573 4.983v-.05z"
          />
          <path
            fill="#FFA897"
            d="M54.691 18.012a176.604 176.604 0 0 0-29.054 0c.883-2.195-12.403 31.719-3.84 68.373 0 0 9.958 3.096 26.994 4.466 17.035 1.37 27.377-.114 27.377-.114 14.348-34.84 6.72-70.416 7.232-68.107a176.473 176.473 0 0 0-28.709-4.618z"
          />
          <path
            fill="#603141"
            d="M30.283 9.664c.154-.8-10.355-2.538-10.24-2.957.551-2.17 7.872-8.424 36.786-4.872 22.45 2.157 30.423 11.825 33.56 15.39 2.252 2.538.332 35.03-6.95 46.627l.575-28.826c.512-4.96-6.4-1.269-30.296-3.49-23.704-2.169-29.988-7.079-30.423-2.118l-4.378 28.484c-3.635-9.25-2.56-25.071-1.37-35.525-7.18-5.342-9.701-10.709-9.944-12.447-.09-.672 22.603.355 22.68-.266z"
          />
          <g fill="#E05C5C">
            <path d="M44.084 69.305c.004-.448.188-.876.512-1.187.325-.312.761-.481 1.213-.47a77.47 77.47 0 0 1 10.944.766c.45.052.86.282 1.138.636.278.355.401.806.341 1.25a1.697 1.697 0 0 1-1.91 1.413 74.629 74.629 0 0 0-10.547-.745 1.698 1.698 0 0 1-1.691-1.663z" />
          </g>
          <g fill="#603141" transform="rotate(2 -1199.032 882.219)">
            <ellipse cx="5.142" cy="7.215" rx="2.556" ry="2.96" transform="rotate(-.573 5.142 7.215)" />
            <ellipse cx="39.226" cy="8.905" rx="2.556" ry="2.96" transform="rotate(-.55 39.226 8.905)" />
            <path d="M8.212 1.323C5.945-.28 2.806-.441.35.917c-.354.205-.457.628-.229.946.228.318.7.41 1.054.205.03 0 3.185-1.79 6.103.318.213.153.5.194.755.105a.706.706 0 0 0 .479-.533.651.651 0 0 0-.275-.64l-.025.005zM43.175 3.014c-2.295-1.601-5.472-1.763-7.958-.405-.298.218-.368.597-.164.887.203.291.617.404.97.264.03 0 3.222-1.79 6.177.317a.853.853 0 0 0 .764.106.71.71 0 0 0 .485-.534.648.648 0 0 0-.28-.639l.006.004z" />
          </g>
        </g>
        <path
          fill="#FFF"
          stroke="#E8E9EB"
          d="M339 10.298V1h9.297v9.298H339zM1 92.107V78h28.213v14.107H1zm33 15.191V98h13v9.298H34zm18 8.424V110h8v5.722h-8zM33.393 8h296.871v9.923H349.181v25.545h-16.772v24.773h-16.774v16.772H40.544V68.241H7V34.696h16.771V17.923h9.622V8z"
        />
        <text fill="#647181" fontFamily="Roboto-Regular, Roboto" fontSize="16" transform="translate(1 1)">
          <tspan x={props.i18n.language === 'zh' ? 90 : 51.949} y="38">
            {props.topText || props.t("You don't have any favorite activities")}
          </tspan>{' '}
          <tspan x="118.516" y="62">
            {props.t('for this ProTrack')}
          </tspan>
        </text>
      </g>
    </BaseIcon>
  )
}

export default withTranslation('user')(NoActivitiesMan)
